import Vue from 'vue'
import Router from 'vue-router'
import {
  routers
} from './router'
import {
  getToken,
  getURLParam
} from "@/utils/common";
import Cookies from 'js-cookie'
 

Vue.use(Router)

export const router = new Router({
  base: process.env.BASE_URL,
  routes: routers,
  // mode: 'history' //hash,history
});


router.beforeEach((to, from, next) => {
  const token = getToken();
  const sysToken = getURLParam("sysToken");
  // const sysClient = getURLParam("sysClient");
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path === "/userNotice" || to.path === "/privacyPage" || to.path === "/pubResourceMsg" || to.path === "/policyDetailTwo"|| to.path === "/pubZqInfo") {
    next()
  } else if (to.path === "/gushuGis" || to.path === "/gushuDetail" || to.path === "/gushuRecord" || to.path === "/treeAnalyse" ||  to.path === "/gushuManage" ||  to.path ==="/gushuRepair" || to.path ==="/oldTree") {
    if (sysToken == 'null' || sysToken == null) {
      let  treeToken = getURLParam("sysToken"); //调用方法获取token
      let treeClient  = getURLParam("sysClient"); //调用方法获取token
      Cookies.set("sys_token", treeToken);
      Cookies.set("sys_client", treeClient);
      next();
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      let info = getURLParam("token"); //调用方法获取token
      Cookies.set("forest_token", info);
      next();
    }
  }


});